import { createContext } from "react";

export type Device = "mobile" | "tablet" | "laptop" | "desktop" | "wide";
export type ThemeType = "light" | "dark";

export function createStore() {
  const store = {
    theme: "light" as ThemeType,
  };
  return store;
}

export type Store = ReturnType<typeof createStore>;

export const StoreContext = createContext<Store | null>(null);
